import React, { useEffect } from "react";
import PurchaseOrder from "../purchase/PurchaseOrder";
import { PurchaseOrderProvider } from "../purchase/hooks/usePurchaseOrder";
import { useNavigate, useParams } from "react-router-dom";

const ReturnOrder = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!orderId) return navigate("/return-history");
  }, [orderId, navigate]);

  if (!orderId) return null;

  return (
    <PurchaseOrderProvider isReturn={true}>
      <PurchaseOrder />
    </PurchaseOrderProvider>
  );
};

export default ReturnOrder;
